/**
 * Helpers
 */
const groupBy = (data: any[], ...keys: string[]) => data.reduce((results, item) => {
  const group = keys.reduce((obj, key) => obj[key] ?? {}, item);
  results[group] = [...(results[group] || []), item];
  return results;
}, {});

class GetLinkedProductsData {
  data: {};

  mainRequestUrls: any[];

  constructor() {
    this.data = {};
    this.init();
  }

  async init() {
    try {
      await this.getRequestUrls();
      await this.getProducts();
      await this.saveToSesseion();
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }

    document.dispatchEvent(new CustomEvent('linkedProductsDataLoaded'));
  }

  async getRequestUrls() {
    return new Promise<void>((resolve) => {
      const requestUrls = [];
      const dataUrl = '/collections/all?view=linked-products-data&page=';
      let i: number;
      if (window.theme.linkedProductsDataPages > 0) {
        for (i = 1; i < window.theme.linkedProductsDataPages + 1; i += 1) {
          const urlFetch = fetch(`${dataUrl}${i}`).then((response) => response.json());
          requestUrls.push(urlFetch);
        }
      } else {
        const urlFetch = fetch(`${dataUrl}${i}`).then((response) => response.json());
        requestUrls.push(urlFetch);
      }
      this.mainRequestUrls = requestUrls;

      resolve();
    });
  }

  /**
   * Retrieves products from multiple request URLs and groups them by reference.
   * @async
   * @returns {Promise} A promise that resolves with the grouped product data.
   */
  async getProducts() {
    try {
      const data = await Promise.all(this.mainRequestUrls);
      const merged = [].concat(...data);
      this.data = groupBy(merged, 'reference');
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  }

  /**
   * Saves the linked-products data to the session storage.
   * @async
   * @function saveToSesseion
   * @returns {Promise<void>}
   */
  async saveToSesseion(): Promise<void> {
    window.sessionStorage.setItem('linked-products', JSON.stringify(this.data));
  }
}

export default GetLinkedProductsData;
